import Tags from '~/src/molecules/Tags/';
import React from 'react';
import tw from 'twin.macro';

const CitusAd = ({ citrusad = [] }) => {
  if (!citrusad.length) return <></>;
  return (
    <Tags css={tw`h-full`} variant={citrusad[0]?.type} ImageURL={citrusad[0]?.image_url}>
      {citrusad[0]?.label}
    </Tags>
  );
};

export default CitusAd;